export default function langIsEn() {
  const lang = localStorage.getItem('lang');
  // default in chinese
  return lang ? lang === 'en' : false;
}


// WEBPACK FOOTER //
// ./src/utils/langIsEn.js